/**
 * @title fsamodal.js: Sub-module for Global pages
 * @description This module is used to display the fsa modal
 * @dependency 
 */
define([], function() {	
	
	var rxsignin = {
			
		init : function() {
			this.createFormValidation();
			this.signInOutContainerInit();
			this.dropdownMenuRedirect();
		},	 
    
		PRESCRIPTION_COUNT_URL: 'PharmacyPrescriptionCountCmd',
		
		signInOutContainerInit: function() {
			
			// TODO: This was loaded from the Header_Data.jspf. Hardocding here, but need to find a better way, to pass this dynamically
			window.COSTCO.rxsignin.prescriptionCountURL = 'PharmacyPrescriptionCountCmd';
			
			 // executes when HTML-Document is loaded and DOM is ready, prior to the (window).load()
			var c = $.cookie('hashedUserId');
			if(c && c != '""') {
				var pC = $.cookie("PrescriptionCount");
				rxsignin.ajaxPrescriptionCount();
			} else {
				$('#header-pharmacy-user-box').hide();
			}
		},
		
		setSelectedPatient: function(){
		  let selectedPatientId = $("#patientList option:selected").attr("id");
		  let displayFlag = $("#patientList option:selected").attr("data-displayFlag");
		  let patientIndex = $("#patientList option:selected").index();
		  let firstName = $("#patientList option:selected").attr("data-firstName");
		  let lastName = $("#patientList option:selected").attr("data-lastName");
		  let pathName = COSTCO.rxPrescriptionStatus.getPathName(location);
		  sessionStorage.setItem("SelectedInfo", selectedPatientId);
		  $('#shopperId').val(selectedPatientId);
		  $('#isDonotDisplayDetailsFlag').val(displayFlag);
		  $('#firstName').val(firstName);
		  $('#lastName').val(lastName);
		  $('#urlPathName').val(pathName);
		  $('#patientSelectorForm').submit();
		},
		
		displaySelectedPatientName: function() {
		    var selshopperId = sessionStorage.getItem("SelectedInfo");  
			if(selshopperId != undefined && selshopperId != '' ) {
		    $('#patientList').val(selshopperId);
			}
		  },
		
		ajaxPrescriptionCount : function() {
			//Delete the cookie before making Ajax call.
			$.cookie('PrescriptionCount', null, { path: '/' });
			$.ajax({
				type: 'POST',
				url: rxsignin.PRESCRIPTION_COUNT_URL, 
				dataType: 'text', 
				success: onSuccess,
				error: onError,
				data: { randomValue : Math.random()}
			});

			function onSuccess(data) {
				var pC = $.cookie("PrescriptionCount");
				var value  =JSON.parse(pC);
				rxsignin.populateData(value);
			}
			
			function onError(data) {
				$('#header-pharmacy-user-box').hide();
			}
			
		},
		populateData : function(data) {
			//If data is null, undefined or empty, show the promo.
			if((data == null) || (data == undefined) || (data == "")){
				$('#header-pharmacy-user-box').hide();
				return;
			}
			//The back end will convert white space characters to '+', do the reverse here. 
			var firstName = (data.PatientFirstName).replace(/\+/g, " ");
			var prescriptionProcessed = data.PrescriptionProcessed;
			var prescriptionShipped = data.PrescriptionShipped;
			var truncate = false;
			if(firstName.length > 12){
				firstName = firstName.substring(0, 12);
				truncate = true;
			}
			
			if(firstName === 'New User'){
				$('#patient-first-name').text('Welcome, ' + firstName);			
				$('.info-style').hide();
			} else if($('#patientList').val() == null) { 	 // if no dependent 
				$('#patient-first-name').text('Welcome, ' + firstName);
			} else {											// if dependent is present
				$('#patient-first-name').text('Welcome, ');					
			}
			if(truncate){
				$('#patient-first-name').html($('#patient-first-name').html() + '&hellip;');
			}
			
			if(prescriptionProcessed == 1){
				$('#pres-processed-count-text').text("Prescription Processing");
			}
			$('#pres-processed-count').text(prescriptionProcessed);
			
			if(prescriptionShipped == 1){
				$('#pres-shipped-count-text').text("Prescription Shipping");
			}
			$('#pres-shipped-count').text(prescriptionShipped);
			
			$('#header-pharmacy-user-box').show();
		},
		
		createFormValidation : function() {
			
			//defect CIS100073246. If user clicks Sign In button from the sign in section on the
			//home delivery page without entering any credentials,
			//the placeholder text gets misplaced over the Password field. 
			//solution: id for the form was renamed to HDLogonForm. The new form has been included
			//in this file and invalidHandler was added.
			$('#HDLogonForm').validate({
				rules: {
					logonId: {required:true, email:true},
					logonPassword: {required:true}
				   },
				messages: {
					logonId: {email:messages.ERR_INVALID_EMAIL_HD}
				   },
				invalidHandler: function(form, validator) {
//					   TODO: Commented out for rx redesign - CHECK IF THIS IS STILL NEEDED
////					    // invalidate placeholders to fix layout issues in older browsers
//						$('input[placeholder], textarea[placeholder]').placeholder();
////						// clear existing server messages on form resubmit
//						$('.error_msg, .success, .server-error').remove();
//						window.COSTCO.rxsignin.correctAlignment();
					}
			});
			
			$('#HDLogonForm').submit(function() {
				if ($('#option1').is(':checked')) {
					$.cookie('rememberedLogonId', $('#logonId').val(), { expires: 14, path:'/' });
				} else {
					$.cookie('rememberedLogonId', $('#logonId').val(), { expires: -1, path:'/' });
				}
			});

			if ($('#HDLogonForm #errorlogon').val() == 'True'){
				var n = $('#logonId').val();
				$('#logonId').val(n);
			}else{
				var n = $.cookie('rememberedLogonId');
				$('#logonId').val(n);
				$("#option1").prop('checked', n != null);	
			}
		},
		correctAlignment : function() {
			var placeholdersupport = window.COSTCO.rxsignin.isPlaceholderSupported(); 
			var interval;
		    if (placeholdersupport == false) {
			 	$("input[type='text']").focus(function(){
			 		interval = setInterval(correctPlaceholder,100);
		 		});
				$("input[type='text']").blur(function(){
					clearInterval(interval);
				});
			}
		},
		correctPlaceholder : function(){
			var input = $('.PLACEHOLDER-INPUT');
			var label = $('.PLACEHOLDER-LABEL');
			var topPos;
			for(i=0;i<input.length;i++)	{
				topPos = $(input[i]).offset();
				$(label[i]).offset(topPos);
			}
		},
		isPlaceholderSupported : function() {
			var input = document.createElement("input");
		    return ('placeholder' in input);
		},
		
		dropdownMenuRedirect: function() {
			$('.dropdown-menu-redirect').unbind('change').change(function() {
				window.location.href = $(this).val();
			});
		},

	}//end fsamodal object

	// Expose fsamodal to the global scope.
    if (typeof window.COSTCO === "undefined") {
        window.COSTCO = new Object();
    } 
	
    window.COSTCO.rxsignin = rxsignin;
		
	return rxsignin;
    
});


// WEBPACK FOOTER //
// ./js/rx/rxsignin.js